import {
  Alert,
  alertTypes,
  alertVariants,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { removeErrorMessage } from "slices/app/errorSlice";
import { saveSnapshot } from "slices/discovery/actions/snapshot";

const SaveSnapshotModal = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const errorMessage = useSelector((state) => state.error.errorMessage);

  const isEnabled = () => name.trim() !== "";

  const handleNameChange = ({ target: { value } }) => {
    setName(value);
  };

  const handleCancel = () => {
    dispatch(removeErrorMessage);
    dispatch(hideModal(modalTypes.SAVE_SNAPSHOT));
  };

  const handleSave = () => {
    if (isEnabled()) {
      dispatch(saveSnapshot(name.trim()));
    }
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter") {
      handleSave();
    }
  };

  return (
    <Modal
      centered
      show
      backdrop
      className="fade-in"
      data-testid="save-snapshot-modal"
      onDismiss={handleCancel}
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header>
        <b>Save current snapshot</b>
      </Modal.Header>
      <Modal.Body>
        {errorMessage && (
          <Alert
            variant={alertVariants.warning}
            text={errorMessage}
            type={alertTypes.inline}
            hideCloseButton
          />
        )}
        <input
          autoFocus
          value={name}
          type="text"
          required
          placeholder="Enter snapshot name"
          className="form__field_text"
          onChange={handleNameChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={handleCancel}>
          Cancel
        </NewButton>

        <NewButton
          variant={NewButtonVariant.l1}
          onClick={handleSave}
          disabled={!isEnabled()}
        >
          Save
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveSnapshotModal;
